
import Vconsole from 'vconsole'
window.Vconsole = Vconsole;
let vConsole = {}
let state = 0;
export default {
    showSwitch() {
        state = 1;
        if (vConsole && vConsole.showSwitch) {
            setTimeout(() => {
                vConsole.showSwitch()
            }, 500);
        } else {
            vConsole = new Vconsole();
            window.vConsole = vConsole;
        }
    },
    hideSwitch() {
        state = 0;
        if (vConsole && vConsole.hideSwitch) {
            setTimeout(() => {
                vConsole.hideSwitch()
            }, 500);
        }
    },
    toggleSwitch() {
        if (state) {
            this.hideSwitch();
        } else {
            this.showSwitch();
        }
    }
};


// WEBPACK FOOTER //
// ./src/utils/vconsole.js